module.exports = __webpack_public_path__ + "media/images/gallery/constellations/order_layer_off-217dc0fc4f54a3d81a177b53af320bc0.jpg";